import { create } from 'zustand';

interface MapboxSessionState {
  sessionToken: string;
  rotate: () => void;
}

const newToken = (): string =>
  globalThis.crypto?.randomUUID
    ? globalThis.crypto.randomUUID()
    : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;

export const useMapboxSessionStore = create<MapboxSessionState>((set) => ({
  sessionToken: newToken(),
  rotate: () => set({ sessionToken: newToken() }),
}));
